import { computed, ComputedRef, ref } from 'vue';

export type QueryStatus = 'idle' | 'loading' | 'success' | 'error';

export type UseQueryStatusType = {
  setStatus: (queryStatus: QueryStatus) => void;
  isLoading: ComputedRef<boolean>;
  isSuccess: ComputedRef<boolean>;
  isError: ComputedRef<boolean>;
  isIdle: ComputedRef<boolean>;
};

export const useQueryStatus = () : UseQueryStatusType => {
  const status = ref<QueryStatus>('idle');

  const setStatus = (queryStatus: QueryStatus) => {
    status.value = queryStatus;
  };

  const isLoading = computed(() => status.value === 'loading');

  const isSuccess = computed(() => status.value === 'success');

  const isError = computed(() => status.value === 'error');

  const isIdle = computed(() => status.value === 'idle');

  return {
    setStatus,
    isLoading,
    isSuccess,
    isError,
    isIdle,
  };
};
